import React, { useState, useEffect } from "react";
import { Redirect, Route, Link, useParams } from "react-router-dom";

import Subscrib from "../components/Subscrib";
import Swal from "sweetalert2";

//New structure

import GameSlider from "elements/GameElements/GameSlider";
import CategoryGameContainer from "elements/GameElements/CategoryGameContainer";
import Winner from "../components/Winner";
import SeoSection from "../components/SeoSection";
import HomeBanner from "elements/HomeBanner";
import HomeBannerSingle from "elements/HomeBannerSingle";
import StepRightUp from "elements/home/StepRightUp";
import BringOn from "elements/home/BringOn";
import GameMenu from "elements/GameElements/GameMenu";
import ProgressBar from "react-bootstrap/ProgressBar";

export default function Landing(props) {
  const [seconds, setSeconds] = useState(4083958);
  const params = useParams();
  useEffect(() => {
    const interval = setInterval(() => {
      setSeconds((seconds) => seconds + 1);
    }, 60);
    return () => clearInterval(interval);
  }, []);

  const [categoryName, setCategoryName] = useState("Slots");
  const __ = (text) => text;

  useEffect(() => {
    if (params.status == "true") {
      Swal.fire({
        title: "Success!",
        text: "Successfully bought coins package.",
        icon: "success",
        background: "#2e2e2e", // Dark background color
        color: "#fff", // White text color
        customClass: {
          popup: "dark-theme-popup",
          title: "dark-theme-title",
          content: "dark-theme-content",
        },
      });
    } else if (params.status == "false") {
      Swal.fire({
        title: "Warning!",
        text: "Buying coins package failed!",
        icon: "warning",
        background: "#2e2e2e", // Dark background color
        color: "#fff", // White text color
        customClass: {
          popup: "dark-theme-popup",
          title: "dark-theme-title",
          content: "dark-theme-content",
        },
      });
    }
  }, [params.status]);

  // useEffect(() => {
  //   Swal.fire({
  //     title: "Warning!",
  //     text: "Buying coins package failed!",
  //     icon: "error",
  //     background: "#2e2e2e", // Dark background color
  //     color: "#fff", // White text color
  //     customClass: {
  //       popup: "dark-theme-popup",
  //       title: "dark-theme-title",
  //       content: "dark-theme-content",
  //     },
  //   });
  // }, []);

  return (
    <>
      <div className="container-xxl">
        {/* <Banner {...props} /> */}
        {/* <HomeBanner {...props} /> */}
        <HomeBannerSingle {...props} />
        {/* <TopShortMenu /> */}
        {/* <div className="gameHeading">{__("winnabull Games")}</div> */}
        {/* <GameSlider
          categoryName="Popular"
          category="video_slots"
          perPage="20"
          {...props}
        /> */}
        {/* {<GameMenu callFromSlider={false} {...props} />} */}

        <div className="common-heading">
          <div className="heading">No Purchase Necessary</div>
          <div className="sub-heading">
            100% Free Gaming, No Strings Attached. Dive into the action with
            Gold Coins (GC) and Sweepstakes Coins (SC) from the moment you join.
          </div>
        </div>
        {/* <CategoryGameContainer {...props} /> */}
        <div className="real-time-casino-games-block">
          {props.isMobileDevice && (
            <div className="text-content-block">
              <div className="heading-text">
                Play now and <br />
                Get Big Wins
              </div>
              <p className="sub-text">
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum has been the industry's standard dummy
                text ever since the 1500s
              </p>
              <Link to="#" className="commonBtn pushableBtn">
                <span className="front">
                  Free Trial{" "}
                  <svg
                    width="7"
                    height="13"
                    viewBox="0 0 7 13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1 1.5L6 6.5L1 11.5"
                      stroke="white"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
              </Link>
            </div>
          )}
          <div className="top-block">
            <img
              alt=""
              src={require("assets/winnabull/images/logos/logo.svg").default}
            />
          </div>
          <div className="content-block">
            <div className="image-content-block">
              <div className="header-part">
                {/* <div className="text-part">Money Earned From</div> */}
                {/* <div className="drop-down-filter">
                  1 Years
                  <svg
                    width="28"
                    height="16"
                    viewBox="0 0 28 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      opacity="0.05"
                      width="28"
                      height="16"
                      rx="8"
                      fill="white"
                    />
                    <path d="M14 10L11 7L17 7L14 10Z" fill="white" />
                  </svg>
                </div> */}
              </div>
              <img
                alt=""
                src={require("assets/winnabull/images/landings/neon-cards.png")}
              />
              <div className="bluelight-shadow"></div>
              <div className="play-smartly-block">
                <div className="smartly-block-bg"></div>
                <div className="text-portion">
                  <div className="top-text-part">
                    <div className="text">Balance</div>
                    <div className="percent-text">+WINNABULL</div>
                  </div>
                  <div className="amount-text">SC9566</div>
                  <ProgressBar now={60} />
                  <div className="month-gole">Level: Golden Horns</div>
                </div>
              </div>
              <div className="bottom-bar"></div>
            </div>

            {!props.isMobileDevice && (
              <div className="text-content-block">
                <div className="heading-text">
                  Claim Your Coins Now and Start Winning
                </div>
                <p className="sub-text">
                  At Winnabull, earning free Sweepstakes Coins (SC) is easier
                  than ever. Claim yours through our Daily Login Bonuses,
                  exciting Races, VIP / Loyalty rewards, SC bonuses when
                  purchasing Gold Coins or Mail us a request for additional free
                  SC to your account.
                </p>
                <Link to="/games/all" className="commonBtn pushableBtn">
                  <span className="front">
                    Go To Social Casino{" "}
                    <svg
                      width="7"
                      height="13"
                      viewBox="0 0 7 13"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M1 1.5L6 6.5L1 11.5"
                        stroke="white"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </span>
                </Link>
              </div>
            )}
          </div>
          <div className="footer-block">
            <div className="heading-text">
              Instant Gameplay—No Strings Attached
            </div>
            <div className="sub-text">
              Join Winnabull today and start playing immediately with <br />{" "}
              Gold Coins and Sweepstakes Coins (SC). Anytime, anywhere.
            </div>
          </div>
        </div>
        <br />
        <br />
        <br />
        <br />
        <div className="common-heading">
          <div className="heading">Winnabull Tiers: Level Up Your Rewards</div>
          <div className="sub-heading">
            At Winnabull, loyalty pays off. The higher your tier, the bigger and
            better the rewards.
          </div>
        </div>
        <div className="vip-levels-area">
          <div className="single-vip-level bronze">
            <img
              alt=""
              src={require("assets/winnabull/images/vip-levels/bronze-medals.png")}
            />
            <h3 className="level-heading">Bronze Bull</h3>
            <div className="level-reward-texts">
              <ul>
                <li>
                  <svg
                    width="14"
                    height="11"
                    viewBox="0 0 14 11"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M13 1.5L4.75 9.75L1 6"
                      stroke="white"
                      stroke-opacity="0.6"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  5% extra GC with each purchase
                </li>
                <li>
                  <svg
                    width="14"
                    height="11"
                    viewBox="0 0 14 11"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M13 1.5L4.75 9.75L1 6"
                      stroke="white"
                      stroke-opacity="0.6"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  Free SC spins once per week
                </li>
                <li>
                  <svg
                    width="14"
                    height="11"
                    viewBox="0 0 14 11"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M13 1.5L4.75 9.75L1 6"
                      stroke="white"
                      stroke-opacity="0.6"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  Cash-back incentives
                </li>
              </ul>
            </div>
            <Link to="/loyalty-program">
              Learn More{" "}
              <svg
                width="7"
                height="13"
                viewBox="0 0 7 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1 1.5L6 6.5L1 11.5"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </Link>
          </div>
          <div className="single-vip-level silver">
            <img
              alt=""
              src={require("assets/winnabull/images/vip-levels/silver-medals.png")}
            />
            <h3 className="level-heading">Silver Charger</h3>
            <div className="level-reward-texts">
              <ul>
                <li>
                  <svg
                    width="14"
                    height="11"
                    viewBox="0 0 14 11"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M13 1.5L4.75 9.75L1 6"
                      stroke="white"
                      stroke-opacity="0.6"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  10% extra GC with each purchase
                </li>
                <li>
                  <svg
                    width="14"
                    height="11"
                    viewBox="0 0 14 11"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M13 1.5L4.75 9.75L1 6"
                      stroke="white"
                      stroke-opacity="0.6"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  Free SC spins once per week
                </li>
                <li>
                  <svg
                    width="14"
                    height="11"
                    viewBox="0 0 14 11"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M13 1.5L4.75 9.75L1 6"
                      stroke="white"
                      stroke-opacity="0.6"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  Cash-back incentives
                </li>
                <li>
                  <svg
                    width="14"
                    height="11"
                    viewBox="0 0 14 11"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M13 1.5L4.75 9.75L1 6"
                      stroke="white"
                      stroke-opacity="0.6"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  Winnawheel of Fortune spins
                </li>
              </ul>
            </div>
            <Link to="/loyalty-program">
              Learn More{" "}
              <svg
                width="7"
                height="13"
                viewBox="0 0 7 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1 1.5L6 6.5L1 11.5"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </Link>
          </div>
          <div className="single-vip-level gold">
            <img
              alt=""
              src={require("assets/winnabull/images/vip-levels/gold-medals.png")}
            />
            <h3 className="level-heading">Golden Horns</h3>
            <div className="level-reward-texts">
              <ul>
                <li>
                  <svg
                    width="14"
                    height="11"
                    viewBox="0 0 14 11"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M13 1.5L4.75 9.75L1 6"
                      stroke="white"
                      stroke-opacity="0.6"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  15% extra GC with each purchase
                </li>
                <li>
                  <svg
                    width="14"
                    height="11"
                    viewBox="0 0 14 11"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M13 1.5L4.75 9.75L1 6"
                      stroke="white"
                      stroke-opacity="0.6"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  Free SC spins twice per week
                </li>
                <li>
                  <svg
                    width="14"
                    height="11"
                    viewBox="0 0 14 11"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M13 1.5L4.75 9.75L1 6"
                      stroke="white"
                      stroke-opacity="0.6"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  Cash-back + Rake-back incentives
                </li>
                <li>
                  <svg
                    width="14"
                    height="11"
                    viewBox="0 0 14 11"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M13 1.5L4.75 9.75L1 6"
                      stroke="white"
                      stroke-opacity="0.6"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  Winnawheel of Fortune spins
                </li>
                <li>
                  <svg
                    width="14"
                    height="11"
                    viewBox="0 0 14 11"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M13 1.5L4.75 9.75L1 6"
                      stroke="white"
                      stroke-opacity="0.6"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  Extra bonus SC with each purchase
                </li>
              </ul>
            </div>
            <Link to="/loyalty-program">
              Learn More{" "}
              <svg
                width="7"
                height="13"
                viewBox="0 0 7 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1 1.5L6 6.5L1 11.5"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </Link>
          </div>
          <div className="single-vip-level platinum">
            <img
              alt=""
              src={require("assets/winnabull/images/vip-levels/platinum-medals.png")}
            />
            <h3 className="level-heading">Winnabull Legend</h3>
            <div className="level-reward-texts">
              <ul>
                <li>
                  <svg
                    width="14"
                    height="11"
                    viewBox="0 0 14 11"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M13 1.5L4.75 9.75L1 6"
                      stroke="white"
                      stroke-opacity="0.6"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  20% extra GC with each purchase
                </li>
                <li>
                  <svg
                    width="14"
                    height="11"
                    viewBox="0 0 14 11"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M13 1.5L4.75 9.75L1 6"
                      stroke="white"
                      stroke-opacity="0.6"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  Free SC spins twice per week
                </li>
                <li>
                  <svg
                    width="14"
                    height="11"
                    viewBox="0 0 14 11"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M13 1.5L4.75 9.75L1 6"
                      stroke="white"
                      stroke-opacity="0.6"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  Cash-back + Rake-back incentives
                </li>
                <li>
                  <svg
                    width="14"
                    height="11"
                    viewBox="0 0 14 11"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M13 1.5L4.75 9.75L1 6"
                      stroke="white"
                      stroke-opacity="0.6"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  Winnawheel of Fortune spins
                </li>
                <li>
                  <svg
                    width="14"
                    height="11"
                    viewBox="0 0 14 11"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M13 1.5L4.75 9.75L1 6"
                      stroke="white"
                      stroke-opacity="0.6"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  Extra bonus SC with each purchase
                </li>
                <li>
                  <svg
                    width="14"
                    height="11"
                    viewBox="0 0 14 11"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M13 1.5L4.75 9.75L1 6"
                      stroke="white"
                      stroke-opacity="0.6"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  Free Weekly Winnabull Scratch Cards
                </li>
              </ul>
            </div>
            <Link to="/loyalty-program">
              Learn More{" "}
              <svg
                width="7"
                height="13"
                viewBox="0 0 7 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1 1.5L6 6.5L1 11.5"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </Link>
          </div>
        </div>
        <br />
        <br />
        <br />
        <br />
        <br />
        <GameSlider
          categoryName="Popular Games"
          menuBar={false}
          category="new"
          perPage="20"
          title={true}
          {...props}
        />
        <br />
        <GameSlider
          categoryName="Slot Games"
          menuBar={false}
          category="table_games"
          perPage="20"
          title={true}
          {...props}
        />
        <br />
        {/* <StepRightUp {...props} /> */}
        <Winner {...props} />
        <SeoSection {...props} />
        <Subscrib heading={true} {...props} />
        {/* <BringOn {...props} /> */}
      </div>
    </>
  );
}
